module.exports = __webpack_public_path__ + "static/media/uoa-27.10ffef7c.jpg";